export const loginParams = {
  TOKEN: 'jwtToken',
  PROVIDER_ROUTE: '/app/providers/'
};
